/* ==========================================================================
   Orlivia — comportements des sections personnalisées
   - défilement doux vers une zone de la page (ex. bouton Ajouter au panier)
   - carrousels (image with text, avis clients)
   - « Lire la suite » sur les cartes d'avis
   Autonome : ne dépend d'aucune librairie du thème.
   ========================================================================== */
(function () {
  'use strict';

  // une seule instance, même si plusieurs sections chargent le fichier
  if (window.__oiSectionsLoaded) return;
  window.__oiSectionsLoaded = true;

  /* ---------------------------------------------------------------- utils */

  function headerOffset() {
    var offset = 0;
    var candidates = document.querySelectorAll(
      '[data-header-sticky], .header__wrapper, .site-header, header[role="banner"]'
    );
    for (var i = 0; i < candidates.length; i++) {
      var el = candidates[i];
      var pos = window.getComputedStyle(el).position;
      if (pos === 'fixed' || pos === 'sticky') {
        offset = Math.max(offset, el.getBoundingClientRect().height);
      }
    }
    return offset + 16;
  }

  function prefersReducedMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  /* -------------------------------------------- 1. Boutons « aller vers » */

  function resolveTarget(selector) {
    if (!selector) return null;
    if (selector === 'top') return 'top';
    try {
      return document.querySelector(selector);
    } catch (e) {
      return null;
    }
  }

  // position : où la cible doit se retrouver à l'écran, en % de la hauteur
  // visible (60 = la cible arrive aux deux tiers de l'écran, pas collée en haut).
  function scrollToTarget(selector, position) {
    var target = resolveTarget(selector);
    if (!target) return false;

    var behavior = prefersReducedMotion() ? 'auto' : 'smooth';

    if (target === 'top') {
      window.scrollTo({ top: 0, behavior: behavior });
      return true;
    }

    var docTop = target.getBoundingClientRect().top + window.pageYOffset;
    var sticky = headerOffset();
    var top;

    if (position !== null && !isNaN(position)) {
      var viewport = window.innerHeight || document.documentElement.clientHeight;
      var fromTop = viewport * (position / 100);
      // on garde la cible sous le header collant et dans l'écran
      fromTop = Math.max(sticky, Math.min(fromTop, viewport - 40));
      top = docTop - fromTop;
    } else {
      top = docTop - sticky;
    }

    window.scrollTo({ top: Math.max(top, 0), behavior: behavior });

    // met le focus sur la zone visée (accessibilité) sans re-scroller
    var focusable = target.matches('a, button, input, select, textarea')
      ? target
      : target.querySelector('a, button, input, select, textarea');
    if (focusable) {
      window.setTimeout(function () {
        try {
          focusable.focus({ preventScroll: true });
        } catch (e) {
          /* noop */
        }
      }, 600);
    }
    return true;
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest ? event.target.closest('[data-oi-scroll]') : null;
    if (!trigger) return;

    var selector = trigger.getAttribute('data-oi-scroll');
    var fallback = trigger.getAttribute('data-oi-scroll-fallback');
    var position = trigger.hasAttribute('data-oi-scroll-position')
      ? parseFloat(trigger.getAttribute('data-oi-scroll-position'))
      : null;

    if (scrollToTarget(selector, position)) {
      event.preventDefault();
      return;
    }
    if (fallback && scrollToTarget(fallback, position)) {
      event.preventDefault();
    }
    // sinon : on laisse le lien se comporter normalement
  });

  /* ------------------------------------------- 2. « Lire la suite » avis */

  document.addEventListener('click', function (event) {
    var btn = event.target.closest ? event.target.closest('[data-oi-more]') : null;
    if (!btn) return;
    event.preventDefault();
    var card = btn.closest('[data-oi-review-card]');
    if (!card) return;
    var text = card.querySelector('[data-oi-review-text]');
    if (!text) return;
    var expanded = text.classList.toggle('oi-review-card__text--clamped') === false;
    btn.textContent = expanded
      ? btn.getAttribute('data-label-less') || 'Réduire'
      : btn.getAttribute('data-label-more') || 'Lire la suite';
  });

  // Le bouton n'a de sens que si l'avis est réellement coupé. Il part caché
  // (attribut hidden posé dans le Liquid) et on le montre seulement quand le
  // texte dépasse la hauteur de son cadre.
  function syncMoreButtons(scope) {
    var texts = (scope || document).querySelectorAll('[data-oi-review-text]');
    for (var i = 0; i < texts.length; i++) {
      var text = texts[i];
      var card = text.closest('[data-oi-review-card]');
      var btn = card ? card.querySelector('[data-oi-more]') : null;
      if (!btn) continue;
      // avis déplié : rien à mesurer, le bouton doit rester pour replier
      if (!text.classList.contains('oi-review-card__text--clamped')) continue;
      btn.hidden = text.scrollHeight <= text.clientHeight + 1;
    }
  }

  var moreTimer = null;
  function syncMoreSoon(scope) {
    if (moreTimer) window.clearTimeout(moreTimer);
    moreTimer = window.setTimeout(function () {
      moreTimer = null;
      syncMoreButtons(scope);
    }, 120);
  }

  /* ------------------------------------------------------- 3. Carrousels */

  function OiSlider(root) {
    this.root = root;
    this.track = root.querySelector('[data-oi-track]');
    if (!this.track) return;

    this.realSlides = Array.prototype.slice.call(this.track.querySelectorAll('[data-oi-slide]'));
    this.slides = this.realSlides;
    this.index = 0; // position logique, toujours dans [0, n-1]
    this.visual = 0; // position affichée, qui peut sortir du lot le temps d'une transition
    this.cloneOffset = 0;
    this.timer = null;

    this.fade = root.classList.contains('oi-slider--fade');
    this.loop = root.getAttribute('data-oi-loop') !== 'false';
    this.autoplay = root.getAttribute('data-oi-autoplay') === 'true';
    this.interval = parseInt(root.getAttribute('data-oi-interval'), 10) || 5000;

    // Boucle sans fin : on double le lot de cartes avant et après. Le défilement
    // continue donc au-delà de la dernière carte, et on se repose sur la carte
    // équivalente du lot d'origine dès la transition finie, sans que ça se voie.
    this.infinite = this.loop && !this.fade && this.realSlides.length > 1;
    if (this.infinite) this.buildClones();

    this.prevBtn = root.querySelector('[data-oi-prev]');
    this.nextBtn = root.querySelector('[data-oi-next]');
    this.nav = root.querySelector('[data-oi-nav]');
    this.counter = root.querySelector('[data-oi-counter]');

    this.bind();
    this.update(false);
    if (this.autoplay && this.pageCount() > 1) this.start();
  }

  OiSlider.prototype.buildClones = function () {
    var n = this.realSlides.length;
    var after = document.createDocumentFragment();
    var before = document.createDocumentFragment();
    var i;

    for (i = 0; i < n; i++) {
      after.appendChild(neutralize(this.realSlides[i].cloneNode(true)));
      before.appendChild(neutralize(this.realSlides[i].cloneNode(true)));
    }
    this.track.appendChild(after);
    this.track.insertBefore(before, this.track.firstChild);

    this.cloneOffset = n;
    this.slides = Array.prototype.slice.call(this.track.querySelectorAll('[data-oi-slide]'));
  };

  // un clone ne doit être ni lu par un lecteur d'écran, ni atteignable au
  // clavier, ni porteur d'un identifiant déjà pris dans la page
  function neutralize(node) {
    node.setAttribute('data-oi-clone', 'true');
    node.setAttribute('aria-hidden', 'true');
    node.removeAttribute('id');
    var inner = node.querySelectorAll('[id]');
    var k;
    for (k = 0; k < inner.length; k++) inner[k].removeAttribute('id');
    var focusables = node.querySelectorAll('a, button, input, select, textarea, [tabindex]');
    for (k = 0; k < focusables.length; k++) focusables[k].setAttribute('tabindex', '-1');
    return node;
  }

  OiSlider.prototype.perView = function () {
    if (this.fade) return 1;

    // On mesure d'abord : la largeur des cartes peut être réglée librement,
    // auquel cas le nombre de cartes visibles ne suit plus --OI-PER-VIEW.
    if (this.slides.length) {
      var slideWidth = this.slides[0].getBoundingClientRect().width;
      var viewport = this.root.querySelector('[data-oi-viewport]') || this.root;
      var viewWidth = viewport.getBoundingClientRect().width;
      var gap = parseFloat(window.getComputedStyle(this.track).columnGap) || 0;
      if (slideWidth > 0 && viewWidth > 0) {
        return Math.max(1, Math.round(viewWidth / (slideWidth + gap)));
      }
    }

    var value = window.getComputedStyle(this.root).getPropertyValue('--OI-PER-VIEW-CURRENT');
    var n = parseFloat(value);
    if (n && n > 0) return Math.round(n);
    return 1;
  };

  OiSlider.prototype.pageCount = function () {
    var per = this.perView();
    if (this.infinite) {
      // en boucle, chaque carte peut être la première : autant de positions que de cartes
      return this.realSlides.length > per ? this.realSlides.length : 1;
    }
    return Math.max(1, this.slides.length - per + 1);
  };

  OiSlider.prototype.transitionMs = function () {
    var value = (window.getComputedStyle(this.track).transitionDuration || '').split(',')[0].trim();
    var n = parseFloat(value);
    if (!n) return 0;
    return /ms$/.test(value) ? n : n * 1000;
  };

  OiSlider.prototype.bind = function () {
    var self = this;

    if (this.prevBtn) this.prevBtn.addEventListener('click', function () { self.go(self.index - 1, true); });
    if (this.nextBtn) this.nextBtn.addEventListener('click', function () { self.go(self.index + 1, true); });

    if (this.nav) {
      this.nav.addEventListener('click', function (event) {
        var dot = event.target.closest('[data-oi-dot]');
        if (!dot) return;
        self.go(parseInt(dot.getAttribute('data-oi-dot'), 10), true);
      });
    }

    this.root.addEventListener('mouseenter', function () { self.stop(); });
    this.root.addEventListener('mouseleave', function () { if (self.autoplay) self.start(); });
    this.root.addEventListener('focusin', function () { self.stop(); });

    this.bindDrag();

    // au redimensionnement, la largeur d'une carte change : on repositionne sans
    // animation, sinon le rail glisse tout seul pendant qu'on redimensionne
    this._onResize = function () {
      self.settle();
      self.update(false);
    };
    window.addEventListener('resize', this._onResize);
  };

  /* Glisser à la main : le rail suit le doigt (ou la souris) et se repose sur
     la carte la plus proche au relâcher. Sans ça, le carrousel n'avance qu'au
     bouton ou tout seul, et le geste naturel ne donne rien. */
  OiSlider.prototype.bindDrag = function () {
    var self = this;
    /*
      Le geste ne se prend pas forcement sur le rail : dans « image avec
      texte », un pave de texte est pose par-dessus l'image, en frere du
      diaporama, et il avale le doigt. Le gabarit peut donc designer une
      surface plus large (data-oi-drag-surface) ; c'est elle qui ecoute, et
      c'est toujours le rail qui bouge.
    */
    var surface = (this.root.closest && this.root.closest('[data-oi-drag-surface]')) || this.track;
    // on ne laisse au navigateur que le defilement vertical sur cette surface
    surface.style.touchAction = 'pan-y';
    var startX = 0;
    var startY = 0;
    var startTime = 0;
    var base = 0;
    var axis = null; // 'x' = on fait glisser, 'y' = la page défile
    var active = false;
    var moved = 0;

    function slideStep() {
      if (!self.slides[0]) return 0;
      var gap = parseFloat(window.getComputedStyle(self.track).columnGap) || 0;
      return self.slides[0].getBoundingClientRect().width + gap;
    }

    /* En fondu, le rail ne bouge pas : sans rien de plus, le doigt glisse et
       l'image reste figee, on croit que le diaporama ne se prend pas en main.
       On fait donc suivre le fondu au doigt : l'image en place s'efface a
       mesure que la suivante apparait, en direct. */
    function fadeDur() {
      var v = window.getComputedStyle(self.root).getPropertyValue('--OI-SLIDE-DURATION');
      return parseFloat(v) || 600;
    }

    function fadeSlide(i) {
      var n = self.slides.length;
      if (!n) return null;
      return self.slides[((i % n) + n) % n];
    }

    function fadeFollow(dx, step) {
      var cur = fadeSlide(self.index);
      var nxt = fadeSlide(self.index + (dx < 0 ? 1 : -1));
      if (!cur || !nxt || cur === nxt) return;
      var p = Math.min(1, Math.abs(dx) / (step || 1));
      var k;
      for (k = 0; k < self.slides.length; k++) {
        var sl = self.slides[k];
        sl.style.transition = 'none';
        if (sl === cur) { sl.style.opacity = String(1 - p); sl.style.zIndex = '2'; }
        else if (sl === nxt) { sl.style.opacity = String(p); sl.style.zIndex = '1'; }
        else { sl.style.opacity = ''; sl.style.zIndex = ''; }
      }
    }

    // au relacher, on rend la main au fondu du CSS depuis l'etat atteint au doigt
    function fadeSettle() {
      var k;
      for (k = 0; k < self.slides.length; k++) {
        self.slides[k].style.transition = '';
        self.slides[k].style.opacity = k === self.index ? '1' : '0';
        self.slides[k].style.zIndex = '';
      }
      window.setTimeout(function () {
        var j;
        for (j = 0; j < self.slides.length; j++) {
          self.slides[j].style.opacity = '';
          self.slides[j].style.zIndex = '';
        }
      }, fadeDur() + 60);
    }

    function down(event) {
      if (event.button != null && event.button !== 0) return;
      if (self.pageCount() < 2) return;
      if (event.target.closest && event.target.closest('[data-oi-prev], [data-oi-next], [data-oi-nav]')) return;
      self.settle();
      startX = event.clientX;
      startY = event.clientY;
      startTime = event.timeStamp || 0;
      base = (self.visual + self.cloneOffset) * slideStep();
      axis = null;
      active = true;
      moved = 0;
      self.stop();
    }

    function move(event) {
      if (!active) return;
      var dx = event.clientX - startX;
      var dy = event.clientY - startY;

      if (axis === null) {
        if (Math.abs(dx) < 6 && Math.abs(dy) < 6) return;
        axis = Math.abs(dx) > Math.abs(dy) ? 'x' : 'y';
        if (axis === 'y') { active = false; return; }
        self.root.classList.add('is-dragging');
        if (surface !== self.track) surface.classList.add('is-dragging');
        if (surface.setPointerCapture && event.pointerId != null) {
          try { surface.setPointerCapture(event.pointerId); } catch (e) { /* noop */ }
        }
      }

      moved = dx;
      if (self.fade) {
        event.preventDefault();
        fadeFollow(dx, slideStep());
        return;
      }
      // au bord d'un carrousel non bouclé, on freine au lieu de partir dans le vide
      if (!self.infinite && !self.loop) {
        var max = (self.pageCount() - 1) * slideStep();
        var wanted = base - dx;
        if (wanted < 0) dx = base + (0 - (base - dx)) * 0.6;
        else if (wanted > max) dx = base - max - ((base - dx) - max) * 0.6;
      }
      event.preventDefault();
      self.track.style.transition = 'none';
      self.track.style.transform = 'translate3d(' + -(base - dx) + 'px, 0, 0)';
    }

    function up(event) {
      if (!active && axis !== 'x') { active = false; axis = null; return; }
      var wasDragging = axis === 'x';
      active = false;
      axis = null;
      self.root.classList.remove('is-dragging');
      if (surface !== self.track) surface.classList.remove('is-dragging');
      self.track.style.transition = '';
      if (!wasDragging) return;

      var step = slideStep() || 1;
      var elapsed = ((event.timeStamp || 0) - startTime) || 1;
      var speed = Math.abs(moved) / elapsed; // px/ms
      var jumps = Math.round(-moved / step);
      // un geste vif compte comme une carte, même s'il n'a pas parcouru la moitié
      if (jumps === 0 && (Math.abs(moved) > step * 0.18 || speed > 0.45)) {
        jumps = moved < 0 ? 1 : -1;
      }
      if (jumps === 0) {
        self.update(true);
      } else {
        self.go(self.index + jumps, true);
      }
      if (self.fade) fadeSettle();
      if (self.autoplay) self.start();
    }

    if (window.PointerEvent) {
      surface.addEventListener('pointerdown', down);
      surface.addEventListener('pointermove', move, { passive: false });
      surface.addEventListener('pointerup', up);
      surface.addEventListener('pointercancel', up);
    } else {
      surface.addEventListener('touchstart', function (e) { down(e.touches[0]); }, { passive: true });
      surface.addEventListener('touchmove', function (e) {
        var t = e.touches[0];
        move({ clientX: t.clientX, clientY: t.clientY, preventDefault: function () { e.preventDefault(); } });
      }, { passive: false });
      surface.addEventListener('touchend', function (e) { up({ timeStamp: e.timeStamp }); });
    }

    // un lien ne doit pas s'ouvrir quand on vient de faire glisser le rail
    surface.addEventListener('click', function (event) {
      if (Math.abs(moved) > 8) {
        event.preventDefault();
        event.stopPropagation();
        moved = 0;
      }
    }, true);

    surface.addEventListener('dragstart', function (event) { event.preventDefault(); });
  };

  OiSlider.prototype.go = function (index, userAction) {
    var pages = this.pageCount();

    if (this.infinite && pages > 1) {
      // une transition de bord était peut-être en cours : on la solde d'abord,
      // sinon un enchaînement rapide de clics partirait d'une position fausse
      this.settle();
      var wrapped = ((index % pages) + pages) % pages;
      if (index < 0 || index > pages - 1) {
        // franchissement d'un bord : on passe par les clones, puis on se repose
        this.visual = this.index + (index < 0 ? -1 : 1);
        this.index = wrapped;
        this.update(true);
        this.scheduleSettle();
      } else {
        this.index = wrapped;
        this.visual = wrapped;
        this.update(true);
      }
      if (userAction && this.autoplay) this.start();
      return;
    }

    if (index < 0) index = this.loop ? pages - 1 : 0;
    if (index > pages - 1) index = this.loop ? 0 : pages - 1;
    this.index = index;
    this.visual = index;
    this.update(true);
    if (userAction && this.autoplay) this.start();
  };

  // repose le rail sur la carte d'origine, sans animation : le saut est invisible
  // puisque la carte clonée affichée est identique à celle sur laquelle on retombe
  OiSlider.prototype.settle = function () {
    if (this._settleTimer) {
      window.clearTimeout(this._settleTimer);
      this._settleTimer = null;
    }
    if (this.visual === this.index) return;
    this.visual = this.index;
    this.update(false);
  };

  OiSlider.prototype.scheduleSettle = function () {
    var self = this;
    if (this._settleTimer) window.clearTimeout(this._settleTimer);
    this._settleTimer = window.setTimeout(function () {
      self._settleTimer = null;
      self.settle();
    }, this.transitionMs() + 40);
  };

  OiSlider.prototype.update = function (animate) {
    var pages = this.pageCount();
    if (this.index > pages - 1) this.index = pages - 1;
    if (this.visual > pages - 1 && !this.infinite) this.visual = this.index;

    if (this.fade) {
      for (var i = 0; i < this.slides.length; i++) {
        this.slides[i].classList.toggle('is-active', i === this.index);
        this.slides[i].setAttribute('aria-hidden', i === this.index ? 'false' : 'true');
      }
    } else if (this.slides[0]) {
      var gap = parseFloat(window.getComputedStyle(this.track).columnGap) || 0;
      var slideWidth = this.slides[0].getBoundingClientRect().width;
      var offset = (this.visual + this.cloneOffset) * (slideWidth + gap);
      if (animate === false) this.track.style.transition = 'none';
      this.track.style.transform = 'translate3d(' + -offset + 'px, 0, 0)';
      if (animate === false) {
        // on force le navigateur à appliquer la position avant de rendre la
        // transition, sinon le saut serait animé lui aussi
        void this.track.offsetHeight;
        this.track.style.transition = '';
      }
    }

    var noLimit = this.loop || this.infinite;
    if (this.prevBtn && !noLimit) this.prevBtn.disabled = this.index === 0;
    if (this.nextBtn && !noLimit) this.nextBtn.disabled = this.index >= pages - 1;

    if (this.nav) {
      var dots = this.nav.querySelectorAll('[data-oi-dot]');
      for (var d = 0; d < dots.length; d++) {
        var isActive = parseInt(dots[d].getAttribute('data-oi-dot'), 10) === this.index;
        dots[d].classList.toggle('is-active', isActive);
        dots[d].setAttribute('aria-current', isActive ? 'true' : 'false');
        dots[d].hidden = d > pages - 1;
      }
    }
    if (this.counter) this.counter.textContent = this.index + 1 + ' / ' + pages;

    var single = pages < 2;
    if (this.prevBtn) this.prevBtn.hidden = single;
    if (this.nextBtn) this.nextBtn.hidden = single;
    if (this.nav) this.nav.hidden = single;
  };

  OiSlider.prototype.start = function () {
    var self = this;
    this.stop();
    if (this.pageCount() < 2) return;
    this.timer = window.setInterval(function () {
      if (document.hidden) return;
      self.go(self.index + 1, false);
    }, this.interval);
  };

  OiSlider.prototype.stop = function () {
    if (this.timer) {
      window.clearInterval(this.timer);
      this.timer = null;
    }
  };

  OiSlider.prototype.destroy = function () {
    this.stop();
    if (this._settleTimer) window.clearTimeout(this._settleTimer);
    if (this._onResize) window.removeEventListener('resize', this._onResize);
  };

  /* -------------------------------- 4. Image + texte superposé (empilé) */

  /* Une fois les colonnes empilées, l'image superposée reste posée sur l'image,
     à l'endroit réglé, et déborde de son cadre : c'est tout l'effet de décalage.
     Reste à lui faire de la place dans le texte. Deux façons, selon le réglage :
     descendre le bloc image, ou creuser un coin dans les dernières lignes.

     Piège des mesures : les blocs portent une animation d'apparition, qui les
     décale tant que la section n'est pas entrée dans l'écran, et les images sont
     chargées en différé. Un rectangle à l'écran ne dit donc pas où se trouvent
     vraiment les blocs. On mesure la rangée en coordonnées de mise en page
     (offsetTop / offsetHeight), que l'animation ne touche pas, et on ne compare
     des rectangles qu'entre l'image superposée et son cadre : ces deux-là
     bougent ensemble, leur écart reste juste. */

  // hauteur du vrai contenu du texte, la réserve mise à part
  function stackContentHeight(text, reserve) {
    var base = text.offsetTop;
    var max = 0;
    var kids = text.children;
    for (var i = 0; i < kids.length; i++) {
      if (kids[i] === reserve) continue;
      var bottom = kids[i].offsetTop + kids[i].offsetHeight - base;
      if (bottom > max) max = bottom;
    }
    return max;
  }

  // renvoie false si la mesure n'est pas encore fiable : on repassera plus tard
  function layoutStackRow(row) {
    var media = row.querySelector('[data-oi-stack-media]');
    var text = row.querySelector('[data-oi-stack-text]');
    var overlay = row.querySelector('[data-oi-stack-overlay]');
    var reserve = row.querySelector('[data-oi-reserve]');

    // on repart toujours d'une mesure propre, sinon on empile les corrections
    if (media) {
      media.style.removeProperty('--OI-MEDIA-CLEAR');
      media.style.removeProperty('--OI-MEDIA-CLEAR-END');
    }
    if (reserve) {
      reserve.className = 'oi-stack__reserve';
      reserve.removeAttribute('style');
    }
    if (!media || !text || !overlay) return true;

    var gap = parseFloat(row.getAttribute('data-oi-wrap-gap'));
    if (isNaN(gap)) gap = 16;

    var mTop = media.offsetTop;
    var mHeight = media.offsetHeight;
    var mLeft = media.offsetLeft;
    var tTop = text.offsetTop;
    var tHeight = text.offsetHeight;
    var tLeft = text.offsetLeft;
    var tWidth = text.offsetWidth;

    var mBox = media.getBoundingClientRect();
    var oBox = overlay.getBoundingClientRect();

    // images pas encore posées : toute mesure serait fausse
    if (mHeight < 8 || oBox.height < 8 || tHeight < 4) return false;

    var textAbove = tTop + tHeight <= mTop + 1;
    var textBelow = tTop >= mTop + mHeight - 1;
    // colonnes côte à côte : le texte n'est ni au-dessus ni en dessous, rien à faire
    if (!textAbove && !textBelow) return true;

    // de combien l'image superposée sort du cadre, du côté du texte
    var out = textAbove ? mBox.top - oBox.top : oBox.bottom - mBox.bottom;
    if (out > oBox.height) out = oBox.height;
    if (out <= 0) return true;

    // ce qui sépare déjà les deux blocs
    var spacing = textAbove ? mTop - (tTop + tHeight) : tTop - (mTop + mHeight);
    var band = out + gap - spacing;
    if (band <= 1) return true;

    if (!reserve) {
      // option décochée : le bloc image s'écarte, le texte n'est pas touché
      media.style.setProperty(
        textAbove ? '--OI-MEDIA-CLEAR' : '--OI-MEDIA-CLEAR-END',
        Math.round(band) + 'px'
      );
      return true;
    }

    // option cochée : le texte contourne. Le côté et la largeur se lisent sur la
    // position réelle de l'image, pas sur le réglage : une rangée inversée suit.
    var ovLeft = mLeft + (oBox.left - mBox.left);
    var ovRight = mLeft + (oBox.right - mBox.left);
    var side = ovLeft - tLeft <= tLeft + tWidth - ovRight ? 'left' : 'right';
    var width = side === 'left' ? ovRight - tLeft + gap : tLeft + tWidth - ovLeft + gap;
    // il doit toujours rester de quoi écrire
    if (width > tWidth * 0.8) width = tWidth * 0.8;
    if (width <= 0) return true;

    reserve.classList.add('oi-stack__reserve--' + side);
    reserve.style.setProperty('--OI-RESERVE-W', Math.round(width) + 'px');

    var content = stackContentHeight(text, reserve);

    // texte trop court pour absorber la place à faire : il contourne ce qu'il
    // peut, et le bloc image s'écarte du reste
    if (content <= band) {
      reserve.style.setProperty('--OI-RESERVE-H', Math.round(content) + 'px');
      media.style.setProperty(
        textAbove ? '--OI-MEDIA-CLEAR' : '--OI-MEDIA-CLEAR-END',
        Math.round(band - content) + 'px'
      );
      return true;
    }

    reserve.style.setProperty('--OI-RESERVE-H', Math.round(band) + 'px');
    // l'image mord sur les premières lignes : la réserve est déjà au bon endroit
    if (textBelow) return true;

    // elle mord sur les dernières : la réserve descend au bas du texte. Comme
    // raccourcir des lignes rallonge le texte, on remesure ; on ne garde que la
    // plus grande hauteur vue, pour ne jamais réserver trop haut.
    var top = content - band;
    reserve.style.setProperty('--OI-RESERVE-T', Math.round(top) + 'px');
    for (var pass = 0; pass < 4; pass++) {
      var grown = stackContentHeight(text, reserve);
      if (grown <= content + 0.5) break;
      content = grown;
      top = content - band;
      reserve.style.setProperty('--OI-RESERVE-T', Math.round(top) + 'px');
    }
    return true;
  }

  var stackRetry = null;
  var stackTries = 0;

  function layoutStacks(scope) {
    var rows = (scope || document).querySelectorAll('[data-oi-stack-row]');
    var settled = true;
    for (var i = 0; i < rows.length; i++) {
      if (!layoutStackRow(rows[i])) settled = false;
    }
    // une image pas encore posée fausse tout : on repasse, sans s'acharner
    if (!settled && !stackRetry && stackTries < 20) {
      stackTries++;
      stackRetry = window.setTimeout(function () {
        stackRetry = null;
        layoutStacks(document);
      }, 250);
    }
    return settled;
  }

  var stackTimer = null;
  function layoutStacksSoon(scope) {
    if (stackTimer) window.clearTimeout(stackTimer);
    stackTimer = window.setTimeout(function () {
      stackTimer = null;
      layoutStacks(scope);
    }, 120);
  }

  // la hauteur de l'image superposée n'est connue qu'une fois l'image chargée
  function watchStackImages(scope) {
    var imgs = (scope || document).querySelectorAll(
      '[data-oi-stack-row] [data-oi-stack-overlay] img, [data-oi-stack-row] .oi-stack__frame img'
    );
    for (var i = 0; i < imgs.length; i++) {
      if (imgs[i].hasAttribute('data-oi-watched')) continue;
      imgs[i].setAttribute('data-oi-watched', 'true');
      if (imgs[i].complete) continue;
      imgs[i].addEventListener('load', function () { layoutStacksSoon(document); });
    }
  }

  /* Filet de sécurité : dès qu'un bloc change de taille (image posée, police
     chargée, largeur d'écran, réglage modifié dans l'éditeur), on remesure. Le
     calcul repart toujours de zéro, donc un second passage donne le même
     résultat et tout s'arrête là. */
  var stackSizeWatcher = null;
  function watchStackBoxes(scope) {
    if (typeof window.ResizeObserver !== 'function') return;
    if (!stackSizeWatcher) {
      stackSizeWatcher = new window.ResizeObserver(function () {
        layoutStacksSoon(document);
      });
    }
    var boxes = (scope || document).querySelectorAll(
      '[data-oi-stack-media], [data-oi-stack-text]'
    );
    for (var i = 0; i < boxes.length; i++) {
      if (boxes[i].hasAttribute('data-oi-observed')) continue;
      boxes[i].setAttribute('data-oi-observed', 'true');
      stackSizeWatcher.observe(boxes[i]);
    }
  }

  /* ------------------------------------------------------ initialisation */

  var instances = [];

  function initIn(scope) {
    var roots = (scope || document).querySelectorAll('[data-oi-slider]');
    for (var i = 0; i < roots.length; i++) {
      if (roots[i].hasAttribute('data-oi-ready')) continue;
      roots[i].setAttribute('data-oi-ready', 'true');
      instances.push(new OiSlider(roots[i]));
    }
  }

  function boot() {
    initIn(document);
    // après les sliders : les clones existent, leurs boutons sont mesurés aussi
    syncMoreButtons(document);
    watchStackImages(document);
    watchStackBoxes(document);
    layoutStacks(document);
    // les polices changent la hauteur du texte, donc la troncature et la réserve
    if (document.fonts && document.fonts.ready && document.fonts.ready.then) {
      document.fonts.ready.then(function () {
        syncMoreButtons(document);
        layoutStacks(document);
      });
    }
  }

  window.addEventListener('resize', function () {
    syncMoreSoon(document);
    stackTries = 0;
    layoutStacksSoon(document);
  });
  window.addEventListener('load', function () { layoutStacks(document); });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Éditeur de thème : re-init au chargement/déplacement d'une section
  document.addEventListener('shopify:section:load', function (event) {
    initIn(event.target);
    syncMoreButtons(event.target);
    watchStackImages(event.target);
    watchStackBoxes(event.target);
    stackTries = 0;
    layoutStacks(event.target);
  });
  document.addEventListener('shopify:section:unload', function () {
    instances = instances.filter(function (instance) {
      if (instance.root && !document.body.contains(instance.root)) {
        instance.destroy();
        return false;
      }
      return true;
    });
  });
  document.addEventListener('shopify:block:select', function (event) {
    var root = event.target.closest ? event.target.closest('[data-oi-slider]') : null;
    if (!root) return;
    for (var i = 0; i < instances.length; i++) {
      if (instances[i].root !== root) continue;
      var slide = event.target.closest('[data-oi-slide]');
      if (!slide) return;
      var idx = instances[i].realSlides.indexOf(slide);
      if (idx > -1) instances[i].go(idx, true);
    }
  });
})();
